import styled from 'styled-components';

export const Input = styled.input`
  appearance: none;
  background: none;
  background-color: #fcfdfe;
  border-radius: 2px;
  box-shadow: none;
  color: #707478;
  font-size: 13px;
  border: 1px solid #d1d5da;
  padding: 14px 21px 13px;
  margin: 5px auto;
  width: 100%;
  box-sizing: border-box;
  outline: 0;
  border-radius: 3px;
  height: 45px;
  line-height: 15px;
  margin: 6px 0 0 0;
  padding: 14px 20px 14px;
  position: relative;

  &:active,
  &:focus {
    border: 1px solid #7fb1f4;
  }
  &::placeholder {
    color: #aeafaf;
  }
  &[disabled] {
    background-color: #ecf0f3;
  }
`;

export const InputContainer = styled.div<{ margin: number; width?: number }>`
  margin-bottom: ${({ margin }) => (margin ? `${String(margin)}px` : '0')};
  width: ${({ width }) => (width ? `${String(width)}px` : '100%')};
`;

export const InputHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const RemainingCount = styled.span`
  color: #a3afba;
  font-size: 13px;
  line-height: 16px;
`;

export const TextArea = styled.textarea`
  appearance: none;
  background: none;
  background-color: #fcfdfe;
  border-radius: 2px;
  box-shadow: none;
  color: #707478;
  font-size: 13px;
  border: 1px solid #d1d5da;
  padding: 14px 21px 13px;
  margin: 5px auto;
  width: 100%;
  box-sizing: border-box;
  border-radius: 3px;
  height: 75px;
  margin: 6px 0 0 0;
  line-height: 19px;
  padding: 14px 20px 14px;
  vertical-align: top;
  resize: none;
  width: 100%;

  &:active,
  &:focus {
    border: 1px solid #7fb1f4;
    outline: none;
  }
  &::placeholder {
    color: #aeafaf;
  }
`;

export const TextAreaContainer = styled.div`
  margin-bottom: 26px;
  width: ${({ width }: { width: number }) => (width ? `${width}px` : '100%')};
`;

export const MenuDesignSectionLabel = styled.label`
  color: #969ea5;
  font-size: 11px;
  font-style: normal;
  font-weight: bold;
  line-height: 150%;
  text-align: left;
  text-transform: uppercase;

  &.has-info-icon {
    display: flex;
    flex: 0 0 auto;
    position: relative;

    img {
      position: relative;
      top: -1px;
    }
  }
`;
